import 'core-js/features/promise/finally';
import 'core-js/features/object/entries';
import 'core-js/features/object/values';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
